import { selectProductTokenByName } from '@rsos/sinatra';
import { getProductName } from './metaTags';

/**
 * return productToken and productTokenExpiration for
 * Capstone/Capstone-Pre-Production.
 * @param {Object} sinatra - sinatra state
 */
export const getProductToken = sinatra => {
  const productName = getProductName();
  const { token: productToken, expiration: productTokenExpiration } =
    selectProductTokenByName(sinatra, productName);
  return {
    productToken,
    productTokenExpiration,
  };
};
